// Real partner URLs with UTM tracking. Single source of truth — replace homepages with
// real affiliate tracking URLs (and adjust UTM params) when partner programs are signed.
const UTM_PARAMS = "utm_source=vatcalc.eu&utm_medium=referral&utm_campaign=vat-calculator-2026";

const withUtm = (url, slot) => `${url}?${UTM_PARAMS}&utm_content=${slot}`;

export const AFFILIATE_LINKS = {
    // banner-cta = top sticky banner; card-cta = "Get started" button; partner-* = per-partner cards
    bannerCta: withUtm("https://quaderno.io", "banner"),
    cardCta: withUtm("https://quaderno.io", "card-cta"),
    quaderno: withUtm("https://quaderno.io", "partner-quaderno"),
    taxually: withUtm("https://taxually.com", "partner-taxually"),
    avalara: withUtm("https://avalara.com", "partner-avalara"),
};
